export enum PlotPhaseName {
  Induction = 'Induction',
  Maintenance = 'Maintenance',
  Rewarming = 'Rewarming',
  Normothermia = 'Normothermia',
  Unknown = 'Unknown'
}